define('lq/types',[
    'globalize',
    'underscore',
    'lq/constants'
], function (globalize, _, constants) {

    var yyyy_mm_dd = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

    var isDate = function (value) {
        return value != null &&
            (_.isDate(value) || (value.constructor === String && value.match(yyyy_mm_dd) != null));
    };

    var isString = function (value) {
        return typeof (value) === 'string';
    };

    var isBoolean = function (value) {
        return typeof (value) === 'boolean';
    };

    var parseBoolean = function (value) {
        value = value.toLowerCase();

        if (value === 'true')
            return true;

        if (value === 'false')
            return false;

        throw new Error('The value "' + value + '" cannot be converted to a boolean.');
    };

    var parseDate = function (value) {
        if (_.isDate(value))
            return value;

        return globalize.parseDate(value, constants.licquidDateFormat);
    };

    return {
        isDate: isDate,
        isString: isString,
        isBoolean: isBoolean,
        parseBoolean: parseBoolean,
        parseDate: parseDate
    };
});
